export const toggleTheme = (currentTheme) => ({
    type: "TOGGLE_THEME",
    currentTheme
});